/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { IErrorProps } from "../../models";

const GetToastErrorMessages = (errorList: Array<IErrorProps>) => {
  let toastMessages: Array<string> = [];
  errorList.forEach((element: IErrorProps, index) => {
    if (
      (element.errorCode === 400 ||
        element.errorCode === 403 ||
        element.errorCode === 409) &&
      !toastMessages.some((x) => x === element.errorMessage)
    ) {
      toastMessages = [...toastMessages, element.errorMessage];
    }
  });
  return toastMessages;
};

export default GetToastErrorMessages;
